import { render, staticRenderFns } from "./yunsischool.vue?vue&type=template&id=3ff32898&scoped=true"
import script from "./yunsischool.vue?vue&type=script&lang=js"
export * from "./yunsischool.vue?vue&type=script&lang=js"
import style0 from "./yunsischool.vue?vue&type=style&index=0&id=3ff32898&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff32898",
  null
  
)

export default component.exports